import { render, staticRenderFns } from "./MeuPerfilPage.vue?vue&type=template&id=18eaa166&scoped=true"
import script from "./MeuPerfilPage.vue?vue&type=script&lang=js"
export * from "./MeuPerfilPage.vue?vue&type=script&lang=js"
import style0 from "./MeuPerfilPage.vue?vue&type=style&index=0&id=18eaa166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18eaa166",
  null
  
)

export default component.exports